/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFPrivacyInfoResult
 */
export interface CRSFPrivacyInfoResult {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFPrivacyInfoResult
     */
    app_store_links?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyInfoResult
     */
    do_not_sell_link: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFPrivacyInfoResult
     */
    has_gpc: boolean;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof CRSFPrivacyInfoResult
     */
    meta: { [key: string]: { [key: string]: any; }; };
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyInfoResult
     */
    privacy_policy_link: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CRSFPrivacyInfoResult
     */
    social_media_links?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CRSFPrivacyInfoResult
     */
    trackers: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the CRSFPrivacyInfoResult interface.
 */
export function instanceOfCRSFPrivacyInfoResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "do_not_sell_link" in value;
    isInstance = isInstance && "has_gpc" in value;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "privacy_policy_link" in value;
    isInstance = isInstance && "trackers" in value;

    return isInstance;
}

export function CRSFPrivacyInfoResultFromJSON(json: any): CRSFPrivacyInfoResult {
    return CRSFPrivacyInfoResultFromJSONTyped(json, false);
}

export function CRSFPrivacyInfoResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyInfoResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'app_store_links': !exists(json, 'app_store_links') ? undefined : json['app_store_links'],
        'do_not_sell_link': json['do_not_sell_link'],
        'has_gpc': json['has_gpc'],
        'meta': json['meta'],
        'privacy_policy_link': json['privacy_policy_link'],
        'social_media_links': !exists(json, 'social_media_links') ? undefined : json['social_media_links'],
        'trackers': json['trackers'],
    };
}

export function CRSFPrivacyInfoResultToJSON(value?: CRSFPrivacyInfoResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'app_store_links': value.app_store_links,
        'do_not_sell_link': value.do_not_sell_link,
        'has_gpc': value.has_gpc,
        'meta': value.meta,
        'privacy_policy_link': value.privacy_policy_link,
        'social_media_links': value.social_media_links,
        'trackers': value.trackers,
    };
}

